import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import { ClickAwayListener, Paper } from '@material-ui/core';
import storage from '../storage';
import { colorSafe, colorDanger } from '../material-ui-theme';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    zIndex: '1000',
    display: 'flex',
    right: 0,
    top: 56,
    height: 'calc(100vh - 56px)',
    width: 250,

    [theme.breakpoints.up('md')]: {
      width: 350,
      padding: theme.spacing(3),
      top: 64,
      height: 'calc(100vh - 64px)',
    },

    '& .MuiPaper-root': {
      width: '100%',
      height: '100%',
    },

    '& .container': {
      padding: theme.spacing(1),
      width: '100%',
      height: '100%',
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',

      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(2),
      },
    },

    '& .notification': {
      padding: theme.spacing(1),
      backgroundColor: 'var(--color-colorPrimary-main)',
      color: '#fff',
      borderRadius: 4,
      marginBottom: theme.spacing(1),
      fontSize: '0.8rem',

      '&-type': {
        '&-success': {
          backgroundColor: colorSafe.main,
        },
        '&-error': {
          backgroundColor: colorDanger.main,
        },
      },
    },

    '& .source': {
      [theme.breakpoints.up('md')]: {
        marginBottom: 5,
      },
    },

    '& .message': {
      lineHeight: '1.2',
      fontWeight: 600,
      fontSize: '0.875rem',
      marginBottom: 5,

      [theme.breakpoints.up('md')]: {
        marginBottom: theme.spacing(2),
      },
    },

    '& .timestamp': {
      fontSize: '0.685rem',
    },
  },
}));

const Notification = ({ message, source, timestamp, type }) => {
  return (
    <div className={`notification notification-type-${type}`}>
      <div className="source">{source}</div>
      <div className="message">{message}</div>
      <div className="timestamp">
        {timestamp ? moment(timestamp).format('hh:mm A') : ''}
      </div>
    </div>
  );
};

const StoredNotificationsModal = ({ closeStoredNotifications }) => {
  const classes = useStyles();
  const notifications = storage.getItem('notifications') || [];

  return (
    <ClickAwayListener onClickAway={closeStoredNotifications}>
      <div className={classes.root}>
        <Paper elevation={2}>
          <div className="container">
            {notifications.map(({ id, ...restProps }) => (
              <Notification key={id} {...restProps} />
            ))}
          </div>
        </Paper>
      </div>
    </ClickAwayListener>
  );
};

StoredNotificationsModal.propTypes = {
  closeStoredNotifications: PropTypes.func.isRequired,
};

export default StoredNotificationsModal;
